// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles__badge___3A9Mb","percent":"styles__percent___1RwSM"};